<template>
  <!-- 客户管理 -->
  <div>
    <div class="rightMo">
      <div class="filter-container">
        <div class="query-row" v-if="!type">
          <b>客户种类：</b>
          <a-radio-group
            v-model="character.customerType"
            @change="(e) => radioGroupChange(e, 'customerType', 'customerManage')"
          >
            <a-radio value>全部</a-radio>
            <a-radio :value="item.label" v-for="item in clientType" :key="item.label">{{item.value}}</a-radio>
          </a-radio-group>
        </div>
        <div v-if="customType" style="margin-bottom: 10px;">
          <b>分类：</b>
          <a-radio-group v-model="value" @change="onChange">
            <a-radio :value="0">全部</a-radio>
            <a-radio :value="1">客户</a-radio>
            <a-radio :value="2">供应商</a-radio>
          </a-radio-group>
        </div>
        <div class="search-row-6xxl">
          <b>{{titleCol}}：</b>
          <a-input
            v-model="queryDataObj.companyName"
            :placeholder="placeholder"
            class="filter-item search-item"
            @pressEnter="queryClick"
            allow-clear
          />
          <b v-if="!customType">上级客户：</b>
          <a-input
            v-if="!customType"
            v-model="queryDataObj.upperCustomerName"
            placeholder="请输入上级客户"
            class="filter-item search-item"
            @pressEnter="queryClick"
            allow-clear
          />
          <b>所有者：</b>
          <a-input
            v-model="queryDataObj.creator"
            placeholder="输入所有者"
            class="filter-item search-item"
            @pressEnter="queryClick"
            allow-clear
          />
          <!-- <b>创建日期: </b>
          <range-date @change="handleDateChange" ref="createTime" style="width: 240px;margin-left:10px;" class="filter-item search-item"></range-date>-->
        </div>
        <div class="search-row-6xxls">
          <b>创建开始日期：</b>
          <a-date-picker
            @change="onChangeDateStart"
            show-time
            valueFormat="YYYY-MM-DD HH:mm:ss"
            v-model="queryDataObj.createTimeStart"
            class="filter-item search-item"
            style="margin-right: 14px; width: 200px;"
            placeholder="请选择开始日期"
          />
          <b>创建结束日期：</b>
          <a-date-picker
            @change="onChangeDateEnd"
            show-time
            valueFormat="YYYY-MM-DD HH:mm:ss"
            v-model="queryDataObj.createTimeEnd"
            class="filter-item search-item"
            style="margin-right: 14px; width: 200px;"
            placeholder="请选择结束日期"
          />
          <div>
            <a-button type="primary" class="filter-item" @click="queryClick">查询</a-button>
            <advancedSearch
              class="filter-item filter-button"
              @advancedSearch="advancedSearch"
              @save="save"
            />
            <a-button class="filter-item filter-button" @click="resetClick">重置</a-button>
            <span v-if="isChild">
              <a-button
                type="primary"
                v-hasPermission="'customer:add'"
                icon="plus-circle"
                class="filter-item add-but"
                @click="addClick"
                style="margin-left:40px;"
              >{{this.$tree([], 'customerManage/index')}}快速新建</a-button>
            </span>
          </div>
        </div>
        <template v-if="!isChild && !recycleBinShow">
          <a-button
            type="primary"
            v-hasPermission="'customer:add'"
            icon="plus-circle"
            class="filter-item add-but"
            @click="addClick"
          >新建{{this.$tree([], 'customerManage/index')}}</a-button>
          <a-button
            v-hasPermission="'customer:export'"
            icon="download"
            class="filter-item add-but"
            @click="exportClick"
            style="margin-left: 6px;background-color: rgb(250, 173, 20); color: white"
          >导出{{this.$tree([], 'customerManage/index')}}</a-button>
          <!-- <a-dropdown class="filter-item add-but" style="margin-left: 20px;">
            <a-menu slot="overlay">
              <a-menu-item v-hasPermission="'customer:delete'" @click="delsArrs">批量删除</a-menu-item>
            </a-menu>
            <a-button>
              更多操作 <a-icon type="down" />
            </a-button>
          </a-dropdown>-->
        </template>
      </div>
      <div :class="customType ? 'contentdivs' : 'contentdiv'">
        <!-- :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" -->
        <a-table
          :columns="isChild ? filterColumnss : filterColumn"
          :data-source="tableData"
          :loading="tableLoadding"
          size="middle"
          :pagination="pagination"
          :rowKey="(record,index)=>{return index}"
          :scroll="{  y: 456 }"
          :components="isChild ? componentesds : componentesd"
          @change="pageChange"
          bordered
        >
          <template slot="fileIds" slot-scope="text, record">
            <a-icon
              type="paper-clip"
              v-if="record.fileIds && record.fileIds !== null && record.fileIds !==''"
              :style="'color:' + storageColor"
            />
          </template>
          <span v-if="isChild" slot="filterDropdown">
            <a-card>
              <a-checkbox-group
                style="display:grid"
                v-model="columnList"
                :options="checkColumns"
                :defaultValue="checkColumns"
                @change="checkChange"
              />
              <a-tag
                color="green"
                @click="getColumns('customerManages')"
                style="position: absolute; right: 5px; bottom: 5px"
              >确认</a-tag>
            </a-card>
          </span>
          <span v-if="!isChild" slot="filterDropdown">
            <a-card>
              <a-checkbox-group
                style="display:grid"
                v-model="columnList"
                :options="checkColumn"
                :defaultValue="checkColumn"
                @change="checkChange"
              />
              <a-tag
                color="green"
                @click="getColumns('customerManage')"
                style="position: absolute; right: 5px; bottom: 5px"
              >确认</a-tag>
            </a-card>
          </span>
          <template slot="linkName" slot-scope="text, record">
            <a-tooltip placement="bottom">
              <template slot="title">
                <div v-for="(item,index) in record.linkmanList" :key="index">
                  <span>{{item.linkmanName}}：{{item.linkmanTel}}</span>
                </div>
              </template>
              <a-icon
                type="phone"
                v-if="record.linkmanList !== [] && record.linkmanList.length>0"
                :style="'color:' + storageColor"
                style="cursor: pointer;"
              />
            </a-tooltip>
          </template>
          <template slot="companyName" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{record.companyName}}</template>
              <span @click="companyNameClick(record)" class="onClickStyle">{{ record.companyName }}</span>
            </a-tooltip>
          </template>
          <template slot="customerType" slot-scope="text, record">
            <span>{{ clientObj[record.customerType] }}</span>
          </template>
          <template slot="type" slot-scope="text, record">
            <span>{{ record.type === 1 ? '客户' : '供应商' }}</span>
          </template>
          <template slot="operation" slot-scope="text, record">
            <template v-if="!isChild && !recycleBinShow">
              <span v-if="nowUserName === record.creator">
                <span>
                  <a-tooltip>
                    <template slot="title">修改</template>
                    <a-icon
                      type="edit"
                      theme="twoTone"
                      style="font-size: 16px;"
                      twoToneColor="#1890ff"
                      @click="editClick(record)"
                    />
                  </a-tooltip>
                </span>
                <span>
                  <a-divider type="vertical" />
                  <a-popconfirm
                    v-if="tableData.length"
                    title="确定删除这条数据吗?"
                    @confirm="() => onDelete(record.id)"
                  >
                    <a-tooltip>
                      <template slot="title">删除</template>
                      <a-icon
                        type="delete"
                        style="font-size: 16px; cursor: pointer;"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </a-tooltip>
                    <!-- <span class="operationStyle" style="color:red;">删除</span> -->
                  </a-popconfirm>
                </span>
              </span>
              <span v-else>
                <span v-hasPermission="'customer:update'">
                  <a-tooltip>
                    <template slot="title">修改</template>
                    <a-icon
                      type="edit"
                      theme="twoTone"
                      style="font-size: 16px;"
                      twoToneColor="#1890ff"
                      @click="editClick(record)"
                    />
                  </a-tooltip>
                </span>
                <span v-hasPermission="'customer:delete'">
                  <a-divider type="vertical" />
                  <a-popconfirm
                    v-if="tableData.length"
                    title="确定删除这条数据吗?"
                    @confirm="() => onDelete(record.id)"
                  >
                    <a-tooltip>
                      <template slot="title">删除</template>
                      <a-icon
                        type="delete"
                        style="font-size: 16px; cursor: pointer;"
                        theme="twoTone"
                        twoToneColor="red"
                      />
                    </a-tooltip>
                    <!-- <span class="operationStyle" style="color:red;">删除</span> -->
                  </a-popconfirm>
                </span>
              </span>
            </template>
            <template v-if="isChild">
              <span class="operationStyle" style="color:#1890ff;" @click="selectClick(record)">选择</span>
            </template>
            <template v-if="recycleBinShow">
              <span>
                <a-divider type="vertical" />
                <a-popconfirm title="确定恢复该数据吗？" @confirm="() => recovery(record)">
                  <a-tooltip>
                    <template slot="title">恢复</template>
                    <a-icon type="sync" class="pointStyle" style="color:#2db7f5" />
                  </a-tooltip>
                  <!-- <span class="operationStyle" style="color:red;">删除</span> -->
                </a-popconfirm>
              </span>
              <span>
                <a-divider type="vertical" />
                <a-popconfirm title="确定删除这条数据吗？删除无法恢复！" @confirm="() => deleteRecy(record)">
                  <a-tooltip>
                    <template slot="title">删除</template>
                    <a-icon type="delete" class="pointStyle" style="color:red" />
                  </a-tooltip>
                  <!-- <span class="operationStyle" style="color:red;">删除</span> -->
                </a-popconfirm>
              </span>
            </template>
          </template>
        </a-table>
      </div>
    </div>
    <add-edit-vue
      ref="addEditRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      :client-type="clientType"
      @success="addSuccess"
      @close="addClose"
    />
    <!-- <detail-vue
      ref="detailRef"
      :dialog-visible="detailVisible"
      @close="closeDetail"
    />-->
    <click-view ref="detailRef" :dialog-visible="detailVisible" @close="closeDetail" />
  </div>
</template>

<script>
import addEditVue from './addEdit.vue'
import detailVue from './detail.vue'
import clickView from '@/components/view/clickView.vue'
import RangeDate from '@/components/datetime/RangeDate'
import { mixin } from '@/mixin/index.js'
import { getQuery } from '@/mixin/getQuery.js'

// import advancedSearch from '@/components/advancedSearch/index.vue'
export default {
  name: 'Idenx',
  props: {
    isChild: {
      type: Boolean,
      default: false
    },
    recycleBinShow: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    type: {
      default: false
    },
    customTyped: {
      default: {}
    }
  },
  provide () {
    return {
      advancedEnquiries: this
    }
  },
  mixins: [getQuery, mixin],
  components: { addEditVue, detailVue, RangeDate, clickView, advancedSearch: () => import('@/components/advancedSearch/index.vue') },
  data () {
    return {
      dataForm: {},
      storageColor: this.$db.get('COLOR')[0],
      character: {
        customerType: '',
        creator: '',
        createTimeStart: null,
        createTimeEnd: null
      },
      customType: this.type,
      titleCol: '客户名称',
      placeholder: '输入名称',
      nowUserName: this.$db.get('USER').username,
      value: 0,
      tableLoadding: false,
      pagination: {
        pageSize: 10,
        pageNum: 1,
        current: 1,
        total: 0,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      columns: [
        {
          width: 80,
          title: 'ID',
          dataIndex: 'id',
          sorter: (a, b) => a.id - b.id,
          ellipsis: true,
          align: 'center'
        },
        {
          width: 80,
          align: 'center',
          title: '附',
          dataIndex: 'fileIds',
          scopedSlots: { customRender: 'fileIds' }
        },
        {
          width: 80,
          align: 'center',
          title: '联系人',
          dataIndex: 'linkName',
          scopedSlots: { customRender: 'linkName' }
        },
        {
          title: '客户名称',
          dataIndex: 'companyName',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'companyName' }
        },
        {
          title: '编号',
          dataIndex: 'customerCode',
          width: 200
        },
        {
          title: '客户种类',
          dataIndex: 'customerType',
          width: 180,
          scopedSlots: { customRender: 'customerType' }
        },
        {
          title: '所有者',
          width: 160,
          ellipsis: true,
          dataIndex: 'creator'
        },
        {
          title: '创建日期',
          width: 190,
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'operation',
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'customerManage'),
          scopedSlots: { customRender: 'operation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        }
      ],
      columnss: [
        {
          width: 150,
          title: '操作',
          onFilterDropdownVisibleChange: (e) => this.onFilterDropdownVisibleChange(e, 'customerManages'),
          scopedSlots: { customRender: 'operation', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon' }
        },
        {
          width: 150,
          title: '类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '客户/供应商名称',
          width: 200,
          dataIndex: 'companyName',
          ellipsis: true,
          scopedSlots: { customRender: 'companyName' }
        },
        // {
        //   title: '客户种类',
        //   dataIndex: 'customerType',
        //   scopedSlots: { customRender: 'customerType' }
        // },
        {
          title: '所有者',
          width: 160,
          ellipsis: true,
          dataIndex: 'creator'
        },
        {
          title: '创建日期',
          width: 190,
          dataIndex: 'createTime'
        },
        {
          // width: 200,
          title: '编号',
          dataIndex: 'customerCode'
        }
      ],
      tableData: [],
      addVisible: false,
      addTitle: '',
      clientType: [],
      clientObj: {},
      detailVisible: false,
      selectedRowKeys: [],
      advancedEnquiries: [
        {
          type: 'input',
          label: '客户名称',
          key: 'companyName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '上级客户姓名',
          key: 'upperCustomerName',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '编号',
          key: 'customerCode',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'input',
          label: '所有者',
          key: 'creator',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建起始日期',
          key: 'createTimeStart',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'time',
          label: '创建结束日期',
          key: 'createTimeEnd',
          defaultModel: true,
          modelKey: 'queryDataObj'
        },
        {
          type: 'radio',
          label: '客户种类',
          layout: 24,
          key: 'customerType',
          content: [{ value: '', label: '全部' }],
          defaultModel: true,
          modelKey: 'queryDataObj'
        }
        // {
        //   type: 'person',
        //   isOnce: false,
        //   label: '抄送人',
        //   layout: 24,
        //   key: 'user'
        // }
      ]
    }
  },
  created () {
    if (this.isChild) {
      this.geTableColumn('customerManages')
    } else {
      this.geTableColumn('customerManage')
    }
  },
  mounted () {
    if (this.$store.state.queryCriteria.queryList.customerManage) {
      this.character = this.queryDataObj = this.$store.state.queryCriteria.queryList.customerManage
    }
    // this.$bus.$on('eventBus', this.eventBusType)
    setTimeout(() => {
      this.initData(this.character)
    }, 200)
    this.clientType = this.$store.state.account.dictData.customerTypeList
    this.clientObj = this.$store.state.account.dictData.customerTypeObj
    this.$store.state.account.dictData.customerTypeList.forEach(e => {
      this.advancedEnquiries[6].content.push({
        label: e.value,
        value: e.label
      })
    })
    // this.customType = this.dataForm.types
    if (Object.keys(this.customTyped).length !== 0) {
      this.customType = this.customTyped.types
    }
    if (this.customType) {
      this.titleCol = '客户/供应商名称'
    } else {
      this.titleCol = '客户名称'
    }
    this.$forceUpdate()
  },
  methods: {
    // 重置
    resetAdvancedSearch () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
    },
    // 保存并查询
    advancedSearch () {
      this.resetAdvancedSearch()
      this.character = { ...this.character, ...this.dataForm, ...this.queryDataObj }
      this.setQueryList({ customerManage: this.character })
      this.initData(this.character)
    },
    // 直接查询不保存
    save () {
      this.resetAdvancedSearch()
      let character = { ...this.character, ...this.dataForm }
      this.initData(character)
      this.dataForm = {}
    },
    handleDateChange (value) {
      if (value) {
        this.$set(this.character, 'createTimeStart', value[0])
        this.$set(this.character, 'createTimeEnd', value[1])
      }
    },
    // eventBusType (customType) {
    //   console.log('type =>', type)
    //   // this.type = type
    // },
    onChangeDateStart (val, mode) {
      this.queryDataObj.createTimeStart = mode
    },
    onChangeDateEnd (val, mode) {
      this.queryDataObj.createTimeEnd = mode
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    companyNameClick (rowVal) {
      // 校验-是否有权限访问
      this.$get('/customer/followCheck', { dataId: rowVal.id }).then(res => {
        if (res.data.status === 1) {
          if (res.data.data) {
            this.detailVisible = true
            this.$nextTick(() => {
              // this.$refs.detailRef.initData(rowVal, rowVal.id)
              this.$refs.detailRef.openView('customer', rowVal, rowVal.id)
            })
          } else {
            this.$message.warning('暂无权限访问该数据!')
          }
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    closeDetail () {
      this.initData(this.character)
      this.detailVisible = false
    },
    deleteRecy (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 3
      parma.type = 1
      this.$get('/recycle/del', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData(this.character)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    recovery (value) {
      const parma = {}
      if (value.parentId) {
        parma.parentId = value.parentId
      }
      parma.linkId = value.id
      parma.recycleType = 3
      parma.type = 1
      this.$get('/recycle/recover', { ...parma }).then(res => {
        if (res.data.status) {
          this.$message.success(res.data.message)
          this.initData(this.character)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    onChange (e) {
      if (e.target.value === 0) {
        this.initData({ type: '' })
        this.placeholder = '请输入名称'
        this.titleCol = '客户/供应商名称'
        this.character.companyName = ''
        // this.initData(this.character)
      } else if (e.target.value === 1) {
        this.initData({ type: 1 })
        this.placeholder = '请输入客户名称'
        this.titleCol = '客户名称'
        this.character.companyName = ''
        // this.initData(this.character)
      } else if (e.target.value === 2) {
        this.initData({ type: 2 })
        this.placeholder = '请输入供应商名称'
        this.titleCol = '供应商名称'
        this.character.companyName = ''
        // this.initData(this.character)
      }
    },
    queryClick () {
      this.pagination.current = 1
      this.pagination.pageNum = 1
      let character = { ...this.character, ...this.queryDataObj }
      this.character = Object.assign({}, this.character, this.queryDataObj)
      this.initData({ ...character })
      this.setQueryList({ customerManage: character })
    },
    resetClick () {
      this.character = {
        customerType: '',
        creator: ''
      }
      if (this.customType === true) {
        this.value = 0
      }
      this.dataForm = {}
      this.queryDataObj = {}
      let character = { ...this.character, ...this.queryDataObj }
      this.setQueryList({ customerManage: character })
      // this.$refs.createTime.reset()
      this.pagination.current = 1
      this.pagination.pageNum = 1
      this.pagination.pageSize = 10
      this.initData(...this.character)
    },
    exportClick () {
      this.$download('/customer/export', { ...this.character, pageSize: -1, pageNum: -1, type: 1 }, `${new Date().getTime()}${this.$tree([], 'customerManage/index')}.xlsx`)
    },
    initData (params = {}) {
      // console.log(this.character, this.queryDataObj, params, 'params')
      this.tableLoadding = true
      if (this.customType) {
        if (this.value === 0) params.type = ''
        else if (this.value === 1) params.type = 1
        else if (this.value === 2) params.type = 2
      } else {
        params.type = 1
      }
      if (this.type) params.customerType = ''
      if (this.recycleBinShow) {
        params.delFlag = 1
      } else {
        delete params.delFlag
      }
      params.pageSize = this.pagination.pageSize
      params.pageNum = this.pagination.current
      // if (this.character.companyName) params.companyName = this.character.companyName
      // if (this.character.upperCustomerName) params.upperCustomerName = this.character.upperCustomerName
      // if (this.character.customerType) params.customerType = this.character.customerType
      // if (this.character.createTimeStart) params.createTimeStart = this.character.createTimeStart
      // if (this.character.createTimeEnd) params.createTimeEnd = this.character.createTimeEnd
      params = { ...this.character, ...this.queryDataObj, ...params }
      if (this.isChild) {
        this.$get('customer/getAll', params).then(res => {
          if (res.data.status === 1) {
            this.tableData = res.data.data.rows
            this.pagination.total = Number(res.data.data.total)
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          } else {
            this.$message.warning(res.data.message)
          }
        })
      } else {
        this.$get('/customer/list', params).then(res => {
          if (res.data.status === 1) {
            this.tableData = res.data.data.rows
            this.pagination.total = Number(res.data.data.total)
            setTimeout(() => {
              this.tableLoadding = false
            }, 500)
          } else {
            this.$message.warning(res.data.message)
          }
        })
      }
    },
    pageChange (pageVal) {
      // 分页查询
      this.pagination.pageNum = pageVal.current
      this.pagination.pageSize = pageVal.pageSize
      this.pagination.current = pageVal.current
      this.initData(this.character)
    },
    editClick (rowValue) {
      this.addTitle = `[修改]${this.$tree([], 'customerManage/index')}`
      this.addVisible = true
      this.$refs.addEditRef.setForm(rowValue)
    },
    delsArrs () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请勾选需要删除的数据')
        return
      }
      this.$confirm({
        title: '确定删除吗?',
        content: '删除后将无法恢复',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          const idsArr = []
          for (let key of this.selectedRowKeys) {
            idsArr.push(this.tableData[key].id)
          }
          this.onDelete(idsArr.join(','))
        },
        onCancel () {
          this.selectedRowKeys = []
        }
      })
    },
    onDelete (rowId) {
      const deleteArr = [rowId]
      this.$get(`/customer/delete`, { ids: deleteArr }).then(res => {
        if (res.data.status === 1) {
          this.$message.success(res.data.message)
          this.selectedRowKeys = []
          this.initData(this.character)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    addClick () {
      this.addTitle = `[新建]-${this.$tree([], 'customerManage/index')}`
      this.addVisible = true
    },
    addSuccess () {
      this.addVisible = false
      // this.pagination.current = 1
      // this.pagination.pageNum = 1
      this.initData(...this.character)
    },
    addClose () {
      this.addVisible = false
    },
    selectClick (val) {
      this.$emit('selectClick', val)
    }
  }
}
</script>

<style scoped>
.rightMo {
}
.query-row {
  margin-bottom: 14px;
}
.contentdiv {
  padding: 0px 0px 0px 16px;
  width: 83vw;
}
.contentdivs {
  padding: 0px 0px 0px 16px;
  width: 77vw;
}
.add-div {
  text-align: right;
}
.filter-container {
  padding: 4px;
  margin: 10px;
  background-color: #fff;
}
.filter-row {
  margin-bottom: 14px;
}
.filter-button {
  margin-left: 20px;
}
.filter-item {
  display: inline-block;
  vertical-align: middle;
}
.search-item {
  margin-right: 14px;
  width: 200px;
}
.add-but {
  margin-top: 10px;
}
.content-div {
  background-color: #fff;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/customerManage/index.vue